import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const IntroSection = () => {
  return (
    <section className="section-padding bg-white" data-testid="intro-section">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Professional Metal Roofing Services in <span className="text-primary">Greater Sydney</span>
          </h2>
          
          <p className="text-lg text-gray-600 mb-6 leading-relaxed">
            Dezire Metal Roofing provides professional metal roof installation services for homeowners across Greater Sydney. Whether you are building new, renovating, or upgrading an older roof, we install metal roofing systems designed for durability, performance, and a clean modern finish.
          </p>
          
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            We work with quality materials suited to Australian weather conditions and focus on professional workmanship at every stage of the job. From repairs to full roof replacements, we deliver dependable service and results you can trust.
          </p>
          
          <Link to="/our-services">
            <Button 
              size="lg" 
              className="bg-primary hover:bg-accent text-white"
              data-testid="intro-view-services-btn"
            >
              View Our Services
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
